var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1100_13611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7292 30.5C15.9931 30.5 17.8869 28.8862 18.3217 26.75H9.13672C9.57182 28.8862 11.4656 30.5 13.7292 30.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4962 15.4988C22.4912 15.4988 22.4861 15.4999 22.4811 15.4999C17.6574 15.4999 13.7312 11.5748 13.7312 6.75C13.7312 5.42363 14.0363 4.16982 14.5675 3.04234C14.2924 3.01625 14.0136 3 13.7312 3C8.89879 3 4.98125 6.91731 4.98125 11.7499V15.2349C4.98125 17.7086 3.89749 20.0437 1.99617 21.6511C1.3624 22.1924 1.0811 23.0549 1.30861 23.8962C1.57365 24.8749 2.54114 25.5 3.55623 25.5H23.8999C24.9649 25.5 25.9688 24.8099 26.1849 23.7662C26.3524 22.9587 26.0649 22.1524 25.4387 21.6262C23.6212 20.1025 22.5699 17.8636 22.4962 15.4988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7304 6.75008C28.7304 10.2018 25.9323 12.9999 22.4803 12.9999C19.0285 12.9999 16.2305 10.2018 16.2305 6.75008C16.2305 3.29831 19.0285 0.5 22.4803 0.5C25.9323 0.5 28.7304 3.29831 28.7304 6.75008Z",
    fill: "#C084FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1100_13611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d35bd7935e67089020b213ce9cc26fb3.svg";
export { ForwardRef as ReactComponent };